<lib-chip-autocomplete [schema]="schema" [value]="value"></lib-chip-autocomplete>
